// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { EventText_abstract } from './../abstract/SagaSchema/EventText_abstract';
export class EventText extends EventText_abstract {}
